import React from 'react';
import usePagination from '@mui/material/usePagination';
import { Button, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
export const UiPagination = (props:any) => {
  const { items } = usePagination({
...props
  });

  return (
    <nav className="ui-pagination">
      <ul>
        {items.map(({ page, type, selected, ...item }, index) => {
          let children = null;
          if (type === 'start-ellipsis' || type === 'end-ellipsis') {
            children = <span className="ui-pagination__ellipsis">...</span>;
          } else if (type === 'page') {
            children = (
              <Button 
                {...item}
                className={selected ? "ui-pagination__btn ui-pagination__btn--current" :"ui-pagination__btn"}
                variant={selected ? 'outlined' : 'text'}
                color={selected ? 'secondary' : 'inherit'} 
                size="small">
                {page}
              </Button>
            );
          } else {
            children = (
              <IconButton size="small" className="ui-pagination__btn ui-pagination__btn--arrow" {...item}>
                {type === 'previous' ? <ArrowBackIcon /> : <ArrowForwardIcon />}
              </IconButton>
            );
          }

          return <li key={index}>{children}</li>;
        })}
      </ul>
    </nav>
  );
}